import * as styled from '../styles/cta-banner';
import { StatsStrip } from './stats-strip';

type Props = {
  waitlistCount: number | null;
};

export const CtaBanner = ({ waitlistCount }: Props) => (
  <styled.CtaBanner>
    <styled.CtaHeading>
      Stop waiting for word of mouth. Start booking real work.
    </styled.CtaHeading>
    <styled.CtaSub>
      Whether you're a creator, freelancer, or running a trade — turn your
      reputation into demand.
    </styled.CtaSub>
    <styled.CtaStats>
      <StatsStrip waitlistCount={waitlistCount} />
    </styled.CtaStats>
    <styled.CtaButton href="#waitlist">Get more bookings →</styled.CtaButton>
  </styled.CtaBanner>
);
